export enum PaymentDocumentType {
  CREATOR_INVOICE = "CREATOR_INVOICE",
  WIRE_RECEIPT = "WIRE_RECEIPT",
}

export const PAYMENT_DOCUMENT_TYPE_LABELS: Record<PaymentDocumentType, string> = {
  [PaymentDocumentType.CREATOR_INVOICE]: "Nota fiscal do creator",
  [PaymentDocumentType.WIRE_RECEIPT]: "Comprovante de transferência",
};

export interface PaymentDocument {
  id: string;
  paymentId: string;
  documentType: PaymentDocumentType;
  documentUrl: string;
  description?: string | null;
  createdAt: string;
  payment?: {
    id: string;
    creatorId: string;
    status: string;
    value: number;
    paymentDate: string;
  };
}

export interface PendingPaymentDocument {
  id: string;
  documentType: PaymentDocumentType;
  description?: string;
  file?: File;
  createdAt: string;
}

export interface CreatePaymentDocumentPayload {
  paymentId: string;
  documentType: PaymentDocumentType;
  description?: string;
  file?: File;
}

export interface UpdatePaymentDocumentPayload {
  id: string;
  paymentId?: string;
  documentType?: PaymentDocumentType;
  description?: string;
  file?: File;
}

